// @flow
import React, {useCallback, useState} from 'react';
import Page from '../components/Page';
import queryString from 'query-string';

export const usePageTab = (defaultTab?: number) => {
  const [selectedTab, setSelectedTab] = useState<number>(defaultTab ?? 0);

  const onSelectTab = useCallback((t: number) => {
    setSelectedTab(t);
  }, []);

  return {selectedTab, onSelectTab};
};

export const usePage = <T>(
  ClsComponent: React$ComponentType<T>,
  name: string
) => {
  return (props: T) => (
    <Page name={name}>
      <ClsComponent {...props} />
    </Page>
  );
};

export const getPageFromQuery = (search: string) => {
  const q = queryString.parse(search);
  const p = parseInt(q.page, 10);
  return p;
};
